import { connect } from "react-redux";
import SalesforceSetting from "../components/AccountSetting/Salesforce/SalesforceSetting";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";
import { initializeMessage } from '../redux/actions/Common';
import { jobCompleted } from "../redux/actions/Broadcasting";

const mapStateToProps = (state) => ({
  fields: state.salesforce.fields,
  isLoadingFields: state.salesforce.isLoadingFields,
  isLoadingPreview: state.salesforce.isLoadingPreview,
  preview: state.salesforce.preview,
  isJobCompletedLoading: state.broadcasting.isJobCompletedLoading,
  successMessage: state.salesforce.successMessage || state.broadcasting.jobSuccessMessage,
  errorMessage: state.salesforce.errorMessage,
  shortMessage: state.salesforce.shortMessage,
  sobject_name: state.salesforce.sobject_name,
  listview_id: state.salesforce.listview_id,
  mapping: state.salesforce.mapping,
  isLoadingSalesforceUserInfo: state.salesforce.isLoadingSalesforceUserInfo,
  salesforceUserName: state.salesforce.salesforceUserName,
  isLoadingMapping: state.salesforce.isLoadingMapping,
  isRevoking: state.salesforce.isRevoking,
  lastUpdate: state.salesforce.lastUpdate,
  loadingPreviewFailed: state.salesforce.loadingPreviewFailed,
  expiredAccessError: state.salesforce.expiredAccessError,
  user: state.accountSetting.user,
  listviews: state.salesforce.listviews,
  isLoadingListviews: state.salesforce.isLoadingListviews,
  isConfiguring: state.salesforce.isConfiguring,
  enableExport: state.salesforce.enableExport,
  salesforce_integration_setting_id:
    state.salesforce.salesforce_integration_setting_id,
  address_import_mappings_flag: state.salesforce.address_import_mappings_flag,
  exe_export_mappings_flag: state.salesforce.exe_export_mappings_flag,
  timeline_status_export_mappings_flag: state.salesforce.timeline_status_export_mappings_flag,
  isLoadingConfig: state.salesforce.isLoadingConfig,
  isLoadingImportHistories: state.salesforce.isLoadingImportHistories,
  salesforceImportHistories: state.salesforce.salesforceImportHistories
    .toIndexedSeq()
    .toArray(),
  pageInfo_importHistories: state.salesforce.pageInfo_importHistories,
  isLoadingExportHistories: state.salesforce.isLoadingExportHistories,
  salesforceExportHistories: state.salesforce.salesforceExportHistories
    .toIndexedSeq()
    .toArray(),
  pageInfo_exportHistories: state.salesforce.pageInfo_exportHistories,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getSalesforceDescribe(sobject_name) {
    dispatch(actions.getSalesforceDescribe(sobject_name));
  },

  getSalesforcePreview(sobject_name, data) {
    dispatch(actions.getSalesforcePreview(sobject_name, data));
  },

  getSalesforceImportMappings() {
    dispatch(actions.getSalesforceImportMappings());
  },

  getSalesforceUserinfo() {
    dispatch(actions.getSalesforceUserinfo());
  },

  postSalesforceRevoke() {
    dispatch(actions.postSalesforceRevoke());
  },

  getSalesforceSyncLastUpdate() {
    dispatch(actions.getSalesforceSyncLastUpdate());
  },

  postSalesforceSync() {
    dispatch(actions.postSalesforceSync());
  },

  getSalesforceListviews(sobject_name) {
    dispatch(actions.getSalesforceListviews(sobject_name));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceConfig() {
    dispatch(actions.getSalesforceConfig());
  },

  configAndSync(data) {
    dispatch(actions.configAndSync(data));
  },

  postSalesforceConfig(data) {
    dispatch(actions.postSalesforceConfig(data));
  },

  getSalesforceImportHistories(data) {
    dispatch(actions.getSalesforceImportHistories(data));
  },

  getSalesforceExportHistories(data) {
    dispatch(actions.getSalesforceExportHistories(data));
  },

  initializeMessage() {
    dispatch(initializeMessage());
  },

  jobCompleted(userId) {
    dispatch(jobCompleted(userId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceSetting);



// WEBPACK FOOTER //
// ./src/containers/SalesforceSetting.js